import { PrepaymentComponent, PrepaymentComponentCtor } from './Prepayment';
export function createFor<T>() {

	const prepayment: PrepaymentComponentCtor<T> = PrepaymentComponent;
	return {
		Prepayment: prepayment
	};
}
